"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var fee_1 = tslib_1.__importDefault(require("./fee"));
var FeeGroupResource = /** @class */ (function (_super) {
    tslib_1.__extends(FeeGroupResource, _super);
    function FeeGroupResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeeGroupResource.endpoint = '/feegroups';
    FeeGroupResource.MODEL_NAME = 'feegroup';
    FeeGroupResource.related = {
        fees: fee_1.default,
    };
    return FeeGroupResource;
}(base_1.default));
exports.default = FeeGroupResource;
//# sourceMappingURL=feegroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/feegroup.js
// module id = 1dmT
// module chunks = 0